// Define the updateLoadMore function outside of the setInterval function
function updateLoadMore() {
  const locations = document.querySelectorAll('#sl_addresses li:not(.no_stores_found)');
  const numOfLocations = locations.length;
  const colMain = document.querySelector('div#col-main.show-addresses');
  const loadMoreClicked = document.querySelector('.load-more-clicked');

  if (numOfLocations > 4 && !loadMoreClicked) {
    colMain.classList.add('show-load-more');
  } else {
    colMain.classList.remove('show-load-more');
  }
}

// Define the timerll function outside of the setInterval function
function timerll() {
  const addressesList = document.querySelectorAll('#sl_addresses li:not(.no_stores_found)');

  if (addressesList.length) {
    const numOfLocations = addressesList.length;
    if (!document.querySelectorAll('.location-found').length) {
      const loadMoreButton = `<span class="button-cta load-more">LOAD MORE
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
          <path d="M4.5 12L12.5 4M12.5 4H7.16667M12.5 4V9.33333" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      </span>`;
      const locationFound = `<div class="location-found"><b>${numOfLocations}</b> Locations Found</div>`;
      document.querySelector('#sl_addresses').insertAdjacentHTML('beforeend', loadMoreButton);
      document.querySelector('#sl_addresses').insertAdjacentHTML('afterbegin', locationFound);

      setInterval(updateLoadMore, 100);

      document.querySelector('.load-more').addEventListener('click', () => {
        const showLoadMore = document.querySelector('.show-load-more');
        showLoadMore.classList.add('load-more-clicked');
        showLoadMore.classList.remove('show-load-more');
      });

      document.querySelector('input#address_search').addEventListener('change', () => {
        const loadMoreClicked = document.querySelector('.load-more-clicked');
        if (loadMoreClicked) {
          loadMoreClicked.classList.remove('load-more-clicked');
        }
      });
    } else {
      document.querySelectorAll('.location-found b')[0].innerHTML = numOfLocations;
    }
  }
}

// Call the timerll function every 50 milliseconds
setInterval(timerll, 50);

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('#within_distance option').forEach((option) => {
    if (option.innerHTML.includes('KM')) {
      option.innerHTML = option.innerHTML.replace('KM', 'Mi');
    }
  });
});
